// pages/OgrenciListPage.js - SAYFALAMALI HIZLI VERSİYON - OPTIMIZED
import React, { useState, useEffect, useMemo, useCallback, useTransition, useRef } from 'react';
import axiosConfig from "../../../api/axiosConfig";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
// Import components
import OgrenciTableRow from './components/OgrenciTableRow';
import OgrenciFormModal from './components/OgrenciFormModal';
import OgrenciExportModal from './components/OgrenciExportModal';
import OgrenciPastLessonsModal from './components/OgrenciPastLessonsModal';
import OdemeModal from './components/OdemeModal';
import StudentBalanceDetailModal from './components/StudentBalanceDetailModal';
import BulkUploadModal from './components/BulkUploadModal';


const OgrenciListPage = () => {
  console.log('🚀 SAYFA YÜKLENDİ - OgrenciListPage component render oldu');
  const [ogrencis, setOgrencis] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [lessonGroups, setLessonGroups] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [initialDataLoadTime] = useState(Date.now()); // Başlangıç zamanını takip et
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [currentOgrenci, setCurrentOgrenci] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPending, startTransition] = useTransition();
  
  // Sayfalama state'leri
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [perPage, setPerPage] = useState(5);
  
  // Diğer state'ler
  const [isPastLessonsModalOpen, setIsPastLessonsModalOpen] = useState(false);
  const [selectedStudentLessons, setSelectedStudentLessons] = useState([]);
  const [selectedStudentInfo, setSelectedStudentInfo] = useState(null);
  const [loadingLessons, setLoadingLessons] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedStudentForPayment, setSelectedStudentForPayment] = useState(null);
  const [isBalanceDetailModalOpen, setIsBalanceDetailModalOpen] = useState(false);
  const [selectedStudentForBalance, setSelectedStudentForBalance] = useState(null);
  const [isBulkUploadModalOpen, setIsBulkUploadModalOpen] = useState(false);
  
  // Öğretmen ve Öğrenci filtreleme state'leri
  const [teacherFilter, setTeacherFilter] = useState('all');
  const [teacherSearchText, setTeacherSearchText] = useState('');
  const [isTeacherDropdownOpen, setIsTeacherDropdownOpen] = useState(false);
  const [studentFilter, setStudentFilter] = useState('all');
  const [studentSearchText, setStudentSearchText] = useState('');
  const [isStudentDropdownOpen, setIsStudentDropdownOpen] = useState(false);
  
  // Dropdown ref'leri
  const teacherDropdownRef = useRef(null);
  const studentDropdownRef = useRef(null);

  // localStorage'dan sıralama tercihini al, varsayılan olarak son işlem tarihine göre sırala
  const savedSortOption = localStorage.getItem('studentSortOption') || 'recent_transaction';
  const [selectedSortOption, setSelectedSortOption] = useState(savedSortOption);
  
  // İlk yükleme için sortConfig'i hesapla
  const getInitialSortConfig = () => {
    switch(savedSortOption) {
      case 'name_asc': return { key: 'name', direction: 'ASC' };
      case 'name_desc': return { key: 'name', direction: 'DESC' };
      case 'class_asc': return { key: 'sinif', direction: 'ASC' };
      case 'class_desc': return { key: 'sinif', direction: 'DESC' };
      case 'balance_high': return { key: 'kalan_bakiye', direction: 'DESC' };
      case 'balance_low': return { key: 'kalan_bakiye', direction: 'ASC' };
      case 'recent_transaction': return { key: 'last_transaction_date', direction: 'DESC' };
      case 'old_transaction': return { key: 'last_transaction_date', direction: 'ASC' };
      case 'recently_added': return { key: 'created_at', direction: 'DESC' };
      case 'oldest_added': return { key: 'created_at', direction: 'ASC' };
      case 'none': return { key: 'id', direction: 'DESC' };
      default: return { key: 'last_transaction_date', direction: 'DESC' }; // Varsayılan: son işlem tarihine göre
    }
  };
  
  const [sortConfig, setSortConfig] = useState(getInitialSortConfig());
  const [searchTerm, setSearchTerm] = useState('');
  const [inputValue, setInputValue] = useState(''); // Input için ayrı state
  const [selectedIds, setSelectedIds] = useState([]);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [exportModalOpen, setExportModalOpen] = useState(false);
  
  // Filtreleme state'leri
  const [statusFilter, setStatusFilter] = useState('active'); // İlk açılışta aktif öğrencileri göster
  const [registrationStatusFilter, setRegistrationStatusFilter] = useState('all'); // all, 0, 1, 2, 3, 4, 5
  
  // Form data state
  const [formData, setFormData] = useState({
    registration_date: '',
    last_transaction_date: '',
    name: '',
    parent_name: '',
    parent_phone: '',
    phone: '',
    city: '',
    city_id: '',
    district: '',
    district_id: '',
    tam_adres: '',
    registered_system: '',
    class_type: '',
    status: '1',
    registration_status: '0',
    email: '',
    psr: '',
    password: '',
    sinif: [], // Array olarak başlat
    okul: '',
    aciklama: '',
    representative: '',
    tc_kimlik_no: ''
  });
  
  const [selectedColumns, setSelectedColumns] = useState({
    durum: true,
    kayitDurumu: true,
    veli: true,
    sinif: true,
    kayitTarihi: true,
    sirket: true,
    dersler: true,
    ogretmenler: true,
    aciklama: true,
    kalanBakiye: true
  });
  
  // Memoized lookup maps
  const companyMap = useMemo(() => {
    const map = new Map();
    companies.forEach(c => map.set(c.id, c.sirket_adi));
    return map;
  }, [companies]);
  
  const lessonMap = useMemo(() => {
    const map = new Map();
    lessonGroups.forEach(lg => map.set(lg.id, lg.ders_adi));
    return map;
  }, [lessonGroups]);
  
  const teacherMap = useMemo(() => {
    const map = new Map();
    teachers.forEach(t => map.set(t.id, t.adi));
    return map;
  }, [teachers]);
  
  // Arama metnine göre filtrelenmiş öğretmenler
  const filteredTeachers = useMemo(() => {
    if (!teachers || teachers.length === 0) return [];
    if (!teacherSearchText) return teachers;
    
    const searchTerm = teacherSearchText.toLowerCase();
    return teachers.filter(teacher => 
      teacher.adi && teacher.adi.toLowerCase().includes(searchTerm)
    );
  }, [teachers, teacherSearchText]);
  
  // Arama metnine göre filtrelenmiş öğrenciler (dropdown için)
  const filteredStudents = useMemo(() => {
    if (!ogrencis || ogrencis.length === 0) return [];
    if (!studentSearchText) return ogrencis;
    
    const searchTerm = studentSearchText.toLowerCase();
    return ogrencis.filter(student => 
      student.name && student.name.toLowerCase().includes(searchTerm)
    );
  }, [ogrencis, studentSearchText]);
  
  // Optimized getters
  const getCompanyName = useCallback((companyId) => {
    return companyMap.get(parseInt(companyId)) || '-';
  }, [companyMap]);
  
  const getSubjectNames = useCallback((subjects) => {
    if (!Array.isArray(subjects) || subjects.length === 0) return '-';
    
    // Eğer lessonGroups henüz yüklenmemişse loading göster
    if (!lessonGroups || lessonGroups.length === 0) {
      return 'Yüklenirken...';
    }
    
    const names = subjects.map(id => lessonMap.get(parseInt(id)) || id);
    if (names.length <= 3) return names.join(', ');
    return `${names.slice(0, 3).join(', ')} ve ${names.length - 3} tane daha`;
  }, [lessonMap, lessonGroups]);
  
  const getTeacherNames = useCallback((teacherData) => {
    // Boş veya undefined kontrolü
    if (!teacherData) return '-';
    
    // Eğer teachers henüz yüklenmemişse loading göster
    if (!teachers || teachers.length === 0) {
      return 'Yüklenirken...';
    }
    
    let names = [];
    
    // Eğer array ise işle
    if (Array.isArray(teacherData)) {
      if (teacherData.length === 0) return '-';
      
      names = teacherData.map(item => {
        // Eğer item string ise direkt isimdir
        if (typeof item === 'string') {
          return item;
        }
        // Eğer item object ise içinden ismi al
        if (typeof item === 'object' && item !== null) {
          return item.name || item.adi || item.teacher_name || '';
        }
        // Eğer number ise ID'dir, map'ten bak
        if (typeof item === 'number') {
          return teacherMap.get(parseInt(item)) || item;
        }
        return item;
      }).filter(name => name && name !== ''); // Boş değerleri filtrele
    }
    // Eğer tek string ise array yap
    else if (typeof teacherData === 'string') {
      names = [teacherData];
    }
    // Eğer object ise içinden ismi almaya çalış
    else if (typeof teacherData === 'object') {
      const name = teacherData.name || teacherData.adi || teacherData.teacher_name;
      if (name) names = [name];
    }
    
    // Eğer hiç isim yoksa
    if (names.length === 0) return '-';
    
    // İsimleri birleştir ve döndür
    if (names.length <= 3) return names.join(', ');
    return `${names.slice(0, 3).join(', ')} ve ${names.length - 3} tane daha`;
  }, [teacherMap, teachers]);
  
  // Initial data fetch - useCallback ile optimize edildi
  const fetchInitialData = useCallback(async () => {
    console.log('🔍 [DEBUG] TEMEL VERİLER - fetchInitialData başlatıldı');
    try {
      console.log('🔍 [DEBUG] TEMEL VERİLER - API çağrıları yapılıyor...');
      console.log('🔍 [DEBUG] TEMEL VERİLER - /admin/sirkets çağrılacak');
      console.log('🔍 [DEBUG] TEMEL VERİLER - /admin/dersgrubu çağrılacak');
      console.log('🔍 [DEBUG] TEMEL VERİLER - /admin/teachers çağrılacak');

      // Promise.allSettled ile paralel ve güvenli çağrı
      const results = await Promise.allSettled([
        axiosConfig.get('/admin/sirkets'),
        axiosConfig.get('/admin/dersgrubu'),
        axiosConfig.get('/admin/teachers')
      ]);

      console.log('🔍 [DEBUG] TEMEL VERİLER - Tüm API çağrıları tamamlandı');
      console.log('🔍 [DEBUG] TEMEL VERİLER - Results:', results.map((r, i) => ({
        index: i,
        status: r.status,
        hasData: r.status === 'fulfilled' ? !!r.value?.data : false,
        dataLength: r.status === 'fulfilled' ? r.value?.data?.length : 0,
        error: r.status === 'rejected' ? r.reason?.message || r.reason : null
      })));

      // Her bir sonucu kontrol et ve state'i güncelle
      if (results[0].status === 'fulfilled') {
        console.log('🔍 [DEBUG] TEMEL VERİLER - Şirket verisi BAŞARILI:', results[0].value.data?.length, 'adet');
        setCompanies(results[0].value.data || []);
      } else {
        console.error('🔍 [DEBUG] TEMEL VERİLER - Şirket verisi BAŞARISIZ:', results[0].reason);
        console.error('🔍 [DEBUG] TEMEL VERİLER - Şirket hatası detay:', results[0].reason?.response?.status, results[0].reason?.response?.data);
        setCompanies([]);
      }

      if (results[1].status === 'fulfilled') {
        console.log('🔍 [DEBUG] TEMEL VERİLER - Ders grubu verisi BAŞARILI:', results[1].value.data?.length, 'adet');
        setLessonGroups(results[1].value.data || []);
      } else {
        console.error('🔍 [DEBUG] TEMEL VERİLER - Ders grubu verisi BAŞARISIZ:', results[1].reason);
        console.error('🔍 [DEBUG] TEMEL VERİLER - Ders grubu hatası detay:', results[1].reason?.response?.status, results[1].reason?.response?.data);
        setLessonGroups([]);
      }

      if (results[2].status === 'fulfilled') {
        console.log('🔍 [DEBUG] TEMEL VERİLER - Öğretmen verisi BAŞARILI:', results[2].value.data?.length, 'adet');
        setTeachers(results[2].value.data || []);
      } else {
        console.error('🔍 [DEBUG] TEMEL VERİLER - Öğretmen verisi BAŞARISIZ:', results[2].reason);
        console.error('🔍 [DEBUG] TEMEL VERİLER - Öğretmen hatası detay:', results[2].reason?.response?.status, results[2].reason?.response?.data);
        setTeachers([]);
      }

      console.log('🔍 [DEBUG] TEMEL VERİLER - fetchInitialData tamamlandı');
    } catch (error) {
      console.error('🔍 [DEBUG] TEMEL VERİLER - GENEL HATA:', error);
    }
  }, []);
  
  // Initial data fetch
  useEffect(() => {
    console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Component mount edildi, fetchInitialData çağrılıyor...');
    fetchInitialData();
  }, [fetchInitialData]);
  
  // fetchStudentsWithPagination'ı useCallback ile optimize et
  const fetchStudentsWithPagination = useCallback(async () => {
    console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - fetchStudentsWithPagination başlatıldı');
    setLoading(true);
    try {
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Query parametreleri hazırlanıyor...');
      // Query parametreleri oluştur
      const params = new URLSearchParams({
        page: currentPage,
        limit: perPage === 99999 ? 100000 : perPage,
        search: searchTerm,
        sortBy: sortConfig.key,
        sortOrder: sortConfig.direction
      });

      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Params:', params.toString());
      
      // Durum filtresi ekle
      if (statusFilter !== 'all') {
        params.append('status', statusFilter === 'active' ? '1' : '0');
      }
      
      // Kayıt durumu filtresi ekle
      if (registrationStatusFilter !== 'all') {
        params.append('registrationStatus', registrationStatusFilter);
      }
      
      // Sınıf sıralaması için özel parametre ekle
      if (sortConfig.key === 'sinif') {
        params.append('sortType', 'numeric');
      }
      
      // Öğretmen filtresi ekle
      if (teacherFilter !== 'all') {
        params.append('teacherId', teacherFilter);
      }
      
      // Öğrenci filtresi ekle
      if (studentFilter !== 'all') {
        params.append('studentId', studentFilter);
      }
      
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - API çağrısı yapılıyor:', `/admin/ogrencis?${params}`);
      const response = await axiosConfig.get(`/admin/ogrencis?${params}`);

      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - API yanıtı alındı:', response?.status, response?.data ? 'Data var' : 'Data yok');
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Response.data tipi:', typeof response.data, Array.isArray(response.data) ? 'Array' : 'Object');

      // Response işleme
      if (response.data && Array.isArray(response.data)) {
        console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Eski format kullanılıyor, öğrenci sayısı:', response.data.length);
        // Eski format
        let sortedData = response.data;
        
        if (sortConfig.key === 'sinif') {
          sortedData = [...response.data].sort((a, b) => {
            const getClassNumber = (classStr) => {
              if (!classStr) return 999;
              const num = parseInt(classStr.toString().replace(/[^0-9]/g, ''));
              return isNaN(num) ? 999 : num;
            };
            
            const aNum = getClassNumber(a.sinif);
            const bNum = getClassNumber(b.sinif);
            
            return sortConfig.direction === 'ASC' ? aNum - bNum : bNum - aNum;
          });
        }
        
        console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - State güncelleniyor, sortedData:', sortedData?.length, 'adet');
        startTransition(() => {
          setOgrencis(sortedData);
          setTotalPages(1);
          setTotalCount(sortedData.length);
          setSelectedIds([]);
          setExpandedRows(new Set());
        });
        console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Eski format state güncellendi');
      } else {
        console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Yeni format kullanılıyor');
        // Yeni format
        let { data, pagination } = response.data;
        console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Yeni format data:', data?.length, 'adet, pagination:', pagination);
        
        if (sortConfig.key === 'sinif' && data && data.length > 0) {
          data = [...data].sort((a, b) => {
            const getClassNumber = (classStr) => {
              if (!classStr) return 999;
              const num = parseInt(classStr.toString().replace(/[^0-9]/g, ''));
              return isNaN(num) ? 999 : num;
            };
            
            const aNum = getClassNumber(a.sinif);
            const bNum = getClassNumber(b.sinif);
            
            return sortConfig.direction === 'ASC' ? aNum - bNum : bNum - aNum;
          });
        }
        
        console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Yeni format state güncelleniyor...');
        startTransition(() => {
          setOgrencis(data);
          setTotalPages(pagination.totalPages);
          setTotalCount(pagination.totalCount);
          setSelectedIds([]);
          setExpandedRows(new Set());
        });
        console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Yeni format state güncellendi');
      }
    } catch (error) {
      console.error('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - HATA:', error);
      console.error('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Error message:', error?.message);
      console.error('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Error response:', error?.response?.status, error?.response?.data);
    } finally {
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Loading false yapılıyor...');
      setLoading(false);
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - fetchStudentsWithPagination tamamlandı');
    }
  }, [currentPage, sortConfig, perPage, searchTerm, statusFilter, registrationStatusFilter, teacherFilter, studentFilter, companies, lessonGroups, teachers]);
  
  // Öğrenci listesi değişikliklerini izle - İlk veriler yüklendikten sonra
  useEffect(() => {
    console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - useEffect çalışıyor');
    console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - companies.length:', companies.length);
    console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - lessonGroups.length:', lessonGroups.length);
    console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - teachers.length:', teachers.length);

    // Eğer temel veriler henüz yüklenmemişse bekle - teachers boşsa es geç
    const timePassed = Date.now() - initialDataLoadTime;

    // Teachers boşsa es geç, diğerleri için bekle
    if (teachers.length === 0) {
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Teachers boş, es geçiliyor...');
    }

    if ((companies.length === 0 || lessonGroups.length === 0) && timePassed < 3000) {
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Eksik veriler:');
      if (companies.length === 0) console.log('  ❌ companies boş');
      if (lessonGroups.length === 0) console.log('  ❌ lessonGroups boş');
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Geçen süre:', timePassed, 'ms - Bekleniyor...');
      return;
    }

    if (timePassed >= 3000) {
      console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - 3 saniye doldu, eksik veriler olsa da devam ediliyor...');
    }

    console.log('🔍 [DEBUG] ÖĞRENCİ LİSTESİ - Temel veriler hazır, öğrenci listesi çekiliyor...');
    fetchStudentsWithPagination();
  }, [fetchStudentsWithPagination, companies.length, lessonGroups.length, teachers.length, initialDataLoadTime]);
  
  // searchTerm dışarıdan değişirse inputValue'yu senkronize et
  useEffect(() => {
    setInputValue(searchTerm);
  }, [searchTerm]);
  
  // Dışarı tıklamayı algıla
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (teacherDropdownRef.current && !teacherDropdownRef.current.contains(event.target)) {
        setIsTeacherDropdownOpen(false);
      }
      if (studentDropdownRef.current && !studentDropdownRef.current.contains(event.target)) {
        setIsStudentDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  // fetchInitialData fonksiyonu yukarıda useCallback ile tanımlandı
  
  // fetchStudentsWithPagination fonksiyonu yukarıda useCallback ile tanımlandı
  
  // Debounced search handler - cleanup ile optimize edildi
  const debouncedSearch = useMemo(
    () => debounce((value) => {
      startTransition(() => {
        setSearchTerm(value);
        setCurrentPage(1);
      });
    }, 300),
    []
  );
  
  // Cleanup - component unmount'ta debounce'u iptal et
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  
  // Input değişikliğini handle eden fonksiyon - debouncedSearch bağımlılığı eklendi
  const handleSearchInputChange = useCallback((value) => {
    setInputValue(value);
    debouncedSearch(value);
    
    if (value === '') {
      setSearchTerm('');
      setCurrentPage(1);
    }
  }, [debouncedSearch]);
  
  // Sayfa değiştirme fonksiyonları - useCallback ile optimize edildi
  const goToPage = useCallback((page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setCurrentPage(page);
    }
  }, [totalPages, currentPage]);
  
  const goToFirstPage = useCallback(() => goToPage(1), [goToPage]);
  const goToLastPage = useCallback(() => goToPage(totalPages), [goToPage, totalPages]);
  const goToPrevPage = useCallback(() => goToPage(currentPage - 1), [goToPage, currentPage]);
  const goToNextPage = useCallback(() => goToPage(currentPage + 1), [goToPage, currentPage]);
  
  // Sayfa başına kayıt sayısı değiştirme - useCallback ile optimize edildi
  const handlePerPageChange = useCallback((newPerPage) => {
    const value = parseInt(newPerPage);
    
    // Eğer çok fazla kayıt varsa uyarı göster
    if (value === 99999 && totalCount > 2000) {
      if (!window.confirm(
        `${totalCount} kayıt gösterilecek. Bu işlem biraz zaman alabilir ve tarayıcınızı yavaşlatabilir. Devam etmek istiyor musunuz?`
      )) {
        return;
      }
    }
    
    setPerPage(value);
    setCurrentPage(1);
    // Tümünü göster seçildiğinde seçili öğeler temizlensin
    if (value === 99999) {
      setSelectedIds([]);
    }
  }, [totalCount]);
  
  // Handlers - memoized
  const handleSelectChange = useCallback((id) => {
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id]
    );
  }, []);
  
  const handleToggleExpand = useCallback((id) => {
    setExpandedRows(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }, []);
  
  const openFormForCreate = useCallback(() => {
    setCurrentOgrenci(null);
    setFormData({
      registration_date: '',
      last_transaction_date: '',
      name: '',
      parent_name: '',
      parent_phone: '',
      phone: '',
      city: '',
      city_id: '',
      district: '',
      district_id: '',
      tam_adres: '',
      registered_system: '',
      class_type: '',
      status: '1',
      registration_status: '0',
      email: '',
      psr: '',
      password: '',
      sinif: [], // Array olarak başlat
      okul: '',
      aciklama: '',
      representative: '',
      tc_kimlik_no: ''
    });
    setIsFormOpen(true);
  }, []);
  
  const openFormForEdit = useCallback((ogr) => {
    setCurrentOgrenci(ogr);
    
    // Tarihleri input için formatlama fonksiyonu
    const formatDateForInput = (dateStr) => {
      if (!dateStr) return '';
      try {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch {
        return '';
      }
    };
    
    // Telefon numarasını formatlama fonksiyonu
    const formatPhoneForEdit = (phone) => {
      if (!phone) return '';
      // Sadece rakamları al
      const numbers = phone.replace(/\D/g, '');
      // Eğer 0 ile başlıyorsa kaldır
      const cleanNumbers = numbers.startsWith('0') ? numbers.slice(1) : numbers;
      
      // Formatla: (5XX) XXX XX XX
      if (cleanNumbers.length === 0) return '';
      if (cleanNumbers.length <= 3) return `(${cleanNumbers}`;
      if (cleanNumbers.length <= 6) return `(${cleanNumbers.slice(0, 3)}) ${cleanNumbers.slice(3)}`;
      if (cleanNumbers.length <= 8) return `(${cleanNumbers.slice(0, 3)}) ${cleanNumbers.slice(3, 6)} ${cleanNumbers.slice(6)}`;
      return `(${cleanNumbers.slice(0, 3)}) ${cleanNumbers.slice(3, 6)} ${cleanNumbers.slice(6, 8)} ${cleanNumbers.slice(8, 10)}`;
    };
    
    setFormData({
      registration_date: formatDateForInput(ogr.registration_date),
      last_transaction_date: formatDateForInput(ogr.last_transaction_date),
      name: ogr.name || '',
      parent_name: ogr.parent_name || '',
      parent_phone: formatPhoneForEdit(ogr.parent_phone),
      phone: formatPhoneForEdit(ogr.phone),
      city: ogr.city || '',
      city_id: ogr.city_id || '',
      district: ogr.district || '',
      district_id: ogr.district_id || '',
      tam_adres: ogr.tam_adres || '',
      registered_system: ogr.registered_system || '',
      class_type: ogr.class_type || '',
      status: ogr.status !== undefined && ogr.status !== null ? ogr.status.toString() : '1',
      registration_status: ogr.registration_status !== undefined && ogr.registration_status !== null ? ogr.registration_status.toString() : '0',
      email: ogr.email || '',
      psr: ogr.psr || '',
      password: '',
      sinif: Array.isArray(ogr.sinif) ? ogr.sinif : (ogr.sinif ? [ogr.sinif] : []), // Array olarak ayarla
      okul: ogr.okul || '',
      aciklama: ogr.aciklama || '',
      representative: ogr.representative || '',
      tc_kimlik_no: ogr.tc_kimlik_no || ''
    });
    setIsFormOpen(true);
  }, []);
  
  const closeForm = useCallback(() => {
    setIsFormOpen(false);
    setCurrentOgrenci(null);
  }, []);
  
  const handleSubmitForm = useCallback(async (e) => {
    e.preventDefault();
    try {
      if (!currentOgrenci && !formData.password) {
        alert("Yeni öğrenci için parola zorunludur!");
        return;
      }
      
      // Telefon numaralarından sadece rakamları al ve başına 0 ekle
      const cleanParentPhone = formData.parent_phone ? formData.parent_phone.replace(/\D/g, '') : '';
      const cleanPhone = formData.phone ? formData.phone.replace(/\D/g, '') : '';

      // Veritabanında olmayan alanları çıkar (sadece city_id frontend için)
      const { city_id, ...formDataClean } = formData;

      const submitData = {
        ...formDataClean,
        parent_phone: cleanParentPhone ? `0${cleanParentPhone}` : '',
        phone: cleanPhone ? `0${cleanPhone}` : '',
        status: parseInt(formData.status), // Status'u sayıya çevir
        registration_status: parseInt(formData.registration_status), // Registration status'u da sayıya çevir
        psr: formData.psr || formData.password,
        remember_token: null
      };
      
      if (currentOgrenci) {
        await axiosConfig.put(`/admin/ogrencis/${currentOgrenci.id}`, submitData);
      } else {
        await axiosConfig.post('/admin/ogrencis', submitData);
      }
      
      fetchStudentsWithPagination();
      closeForm();
    } catch (error) {
      console.error("Form submit error:", error);
      if (error.response) {
        alert(`Hata: ${error.response.data.error || 'Bir hata oluştu'}`);
      }
    }
  }, [currentOgrenci, formData, fetchStudentsWithPagination, closeForm]);
  
  const handleDelete = useCallback(async (id) => {
    if (!window.confirm('Bu öğrenciyi silmek istediğinize emin misiniz?')) return;
    try {
      await axiosConfig.delete(`/admin/ogrencis/${id}`);
      fetchStudentsWithPagination();
    } catch (error) {
      console.error('Öğrenci silinirken hata:', error);
    }
  }, [fetchStudentsWithPagination]);

  const handleToggleTeacherStatus = useCallback(async (studentId, teacherId) => {
    const numericTeacherId = Number(teacherId);

    if (!studentId || !Number.isFinite(numericTeacherId) || numericTeacherId <= 0) {
      alert('Bu öğretmen için pasife alma işlemi yapılamıyor. Eşleşen ders kaydı bulunamadı.');
      return;
    }

    try {
      // ogretmenders tablosunda bu öğrenci-öğretmen ilişkisinin en son kaydını bulup toggle et
      const response = await axiosConfig.get(`/admin/ogretmenders/find?ogrenci_id=${studentId}&ogretmen_id=${numericTeacherId}`);

      if (response.data && response.data.id) {
        // Toggle işlemini yap
        await axiosConfig.patch(`/admin/ogretmenders/${response.data.id}/toggle-status`);
        // Öğrenci listesini yenile
        await fetchStudentsWithPagination();
      }
    } catch (error) {
      console.error('Öğretmen durumu değiştirilirken hata:', error);
      if (error.response?.status === 404) {
        alert('Bu öğrenci ile öğretmen arasında pasife alınabilecek bir ders kaydı bulunamadı.');
        return;
      }
      alert('Öğretmen durumu değiştirilirken bir hata oluştu.');
    }
  }, [fetchStudentsWithPagination]);

  const handleBatchDelete = useCallback(async () => {
    if (selectedIds.length === 0) return;
    if (!window.confirm('Seçili öğrencileri silmek istediğinize emin misiniz?')) return;
    try {
      await Promise.all(
        selectedIds.map(id => axiosConfig.delete(`/admin/ogrencis/${id}`))
      );
      fetchStudentsWithPagination();
    } catch (error) {
      console.error('Toplu silme hata:', error);
    }
  }, [selectedIds, fetchStudentsWithPagination]);
  
  const fetchStudentLessons = useCallback(async (studentId, studentName) => {
    setLoadingLessons(true);
    setSelectedStudentInfo({ id: studentId, name: studentName });
    try {
      // Backend'e öğrenci ID'sini parametre olarak gönder
      const response = await axiosConfig.get('/admin/ogretmenders', {
        params: {
          ogrenci_id: studentId,
          limit: 100000 // Tüm dersleri getir
        }
      });
      
      // Response yapısını esnek bir şekilde işle
      let studentLessons = [];
      if (response.data) {
        if (response.data.pagination) {
          // Sayfalama ile gelen veri
          studentLessons = response.data.data || [];
        } else if (Array.isArray(response.data.data)) {
          // data içinde array
          studentLessons = response.data.data;
        } else if (Array.isArray(response.data)) {
          // Direkt array
          studentLessons = response.data;
        }
      }
      
      console.log(`Öğrenci ${studentId} için ${studentLessons.length} ders bulundu`);
      setSelectedStudentLessons(studentLessons);
      setIsPastLessonsModalOpen(true);
    } catch (error) {
      console.error('Dersler alınırken hata oluştu:', error);
      alert('Dersler yüklenirken bir hata oluştu!');
    } finally {
      setLoadingLessons(false);
    }
  }, []);
  
  const showPayments = useCallback((studentId, studentName) => {
    setSelectedStudentForPayment({ id: studentId, name: studentName });
    setIsPaymentModalOpen(true);
  }, []);
  
  const showBalanceDetail = useCallback((studentId, studentName) => {
    setSelectedStudentForBalance({ id: studentId, name: studentName });
    setIsBalanceDetailModalOpen(true);
  }, []);
  

  
  const closePastLessonsModal = useCallback(() => {
    setIsPastLessonsModalOpen(false);
    setSelectedStudentLessons([]);
    setSelectedStudentInfo(null);
  }, []);
  
  // Öğrenci paneline giriş yapma fonksiyonu
  const handleLoginAsStudent = useCallback(async (studentId) => {
    try {
      const response = await axiosConfig.post(`/admin/ogrencis/${studentId}/login-as-student`);
      
      if (response.data.token) {
        // Öğrenci token'ını localStorage'a kaydet
        localStorage.setItem('studentToken', response.data.token);
        localStorage.setItem('studentInfo', JSON.stringify(response.data.ogrenci));
        
        // Yeni sekmede öğrenci panelini aç
        window.open('/student', '_blank');
      }
    } catch (error) {
      console.error('Öğrenci paneline giriş yapılamadı:', error);
      alert('Öğrenci paneline giriş yapılırken hata oluştu!');
    }
  }, []);
  
  // Global fonksiyon olarak tanımla (TableRow'dan erişim için)
  useEffect(() => {
    window.handleLoginAsStudent = handleLoginAsStudent;
    return () => {
      delete window.handleLoginAsStudent;
    };
  }, [handleLoginAsStudent]);
  
  const closePaymentModal = useCallback(() => {
    setIsPaymentModalOpen(false);
    setSelectedStudentForPayment(null);
  }, []);
  
  const closeBalanceDetailModal = useCallback(() => {
    setIsBalanceDetailModalOpen(false);
    setSelectedStudentForBalance(null);
  }, []);
  

  
  // localStorage yazma işlemini debounce et
  const saveSortPreference = useMemo(
    () => debounce((sortType) => {
      localStorage.setItem('studentSortOption', sortType);
    }, 500),
    []
  );
  
  const handleSmartSort = useCallback((sortType) => {
    let sortKey = 'id';
    let sortDirection = 'DESC';
    
    switch(sortType) {
      case 'none':
        sortKey = 'id';
        sortDirection = 'DESC';
        break;
      case 'name_asc':
        sortKey = 'name';
        sortDirection = 'ASC';
        break;
      case 'name_desc':
        sortKey = 'name';
        sortDirection = 'DESC';
        break;
      case 'class_asc':
        sortKey = 'sinif';
        sortDirection = 'ASC';
        break;
      case 'class_desc':
        sortKey = 'sinif';
        sortDirection = 'DESC';
        break;
      case 'balance_high':
        sortKey = 'kalan_bakiye';
        sortDirection = 'DESC';
        break;
      case 'balance_low':
        sortKey = 'kalan_bakiye';
        sortDirection = 'ASC';
        break;
      case 'recent_transaction':
        sortKey = 'last_transaction_date';
        sortDirection = 'DESC';
        break;
      case 'old_transaction':
        sortKey = 'last_transaction_date';
        sortDirection = 'ASC';
        break;
      case 'recently_added':
        sortKey = 'created_at';
        sortDirection = 'DESC';
        break;
      case 'oldest_added':
        sortKey = 'created_at';
        sortDirection = 'ASC';
        break;
    }
    
    setSelectedSortOption(sortType);
    saveSortPreference(sortType); // Debounced localStorage yazma
    
    startTransition(() => {
      setSortConfig({ key: sortKey, direction: sortDirection });
      setCurrentPage(1);
    });
  }, [saveSortPreference]);
  
  // Export handlers - TÜM VERİYİ ÇEKİP EXPORT ET
  const handleExportPDF = useCallback(async () => {
    try {
      // Tüm veriyi çek (limit olmadan)
      const response = await axiosConfig.get('/admin/ogrencis?limit=10000&page=1');
      const allData = response.data.data || response.data; // Eski ve yeni format desteği
      
      const doc = new jsPDF();
      
      doc.setFontSize(18);
      doc.text('Öğrenci Raporu', 14, 22);
      doc.setFontSize(11);
      doc.text(new Date().toLocaleDateString('tr-TR'), 14, 30);
      
      const headers = [['Ad Soyad', 'Email']];
      const columnStyles = {};
      let colIndex = 2;
      
      if (selectedColumns.durum) {
        headers[0].push('Durum');
        colIndex++;
      }
      if (selectedColumns.kayitDurumu) {
        headers[0].push('Kayıt Durumu');
        colIndex++;
      }
      if (selectedColumns.veli) {
        headers[0].push('Veli Adı');
        headers[0].push('Veli Tel');
        colIndex += 2;
      }
      if (selectedColumns.sinif) {
        headers[0].push('Sınıf');
        headers[0].push('Okul');
        colIndex += 2;
      }
      if (selectedColumns.kayitTarihi) {
        headers[0].push('Kayıt Tarihi');
        colIndex++;
      }
      if (selectedColumns.sirket) {
        headers[0].push('Şirket');
        colIndex++;
      }
      if (selectedColumns.dersler) {
        headers[0].push('Dersler');
        columnStyles[colIndex] = { cellWidth: 40 };
        colIndex++;
      }
      if (selectedColumns.ogretmenler) {
        headers[0].push('Öğretmenler');
        columnStyles[colIndex] = { cellWidth: 40 };
        colIndex++;
      }
      if (selectedColumns.aciklama) {
        headers[0].push('Açıklama');
        columnStyles[colIndex] = { cellWidth: 40 };
        colIndex++;
      }
      if (selectedColumns.kalanBakiye) {
        headers[0].push('Kalan Bakiye');
        colIndex++;
      }
      
      const data = allData.map(ogr => {
        const row = [
          ogr.name || '-',
          ogr.email || '-'
        ];
        
        if (selectedColumns.durum) {
          row.push(parseInt(ogr.status) === 1 ? 'Aktif' : 'Pasif');
        }
        if (selectedColumns.kayitDurumu) {
          row.push({
            0: 'Devam Ediyor',
            1: 'Derslere Başladı',
            2: 'Vazgeçti',
            3: 'Dersler Bitti',
            4: 'Ödeme Sorunu',
            5: 'Ara Verdi'
          }[ogr.registration_status] || '-');
        }
        if (selectedColumns.veli) {
          row.push(ogr.parent_name || '-');
          row.push(ogr.parent_phone || '-');
        }
        if (selectedColumns.sinif) {
          row.push(ogr.sinif || '-');
          row.push(ogr.okul || '-');
        }
        if (selectedColumns.kayitTarihi) {
          row.push(ogr.registration_date || '-');
        }
        if (selectedColumns.sirket) {
          row.push(getCompanyName(ogr.registered_system));
        }
        if (selectedColumns.dersler) {
          row.push(getSubjectNames(ogr.subjects));
        }
        if (selectedColumns.ogretmenler) {
          row.push(getTeacherNames(ogr.teacher_name));
        }
        if (selectedColumns.aciklama) {
          row.push(ogr.aciklama || '-');
        }
        if (selectedColumns.kalanBakiye) {
          row.push(`${ogr.kalan_bakiye >= 0 ? '+' : ''}${ogr.kalan_bakiye || 0} TL`);
        }
        
        return row;
      });
      
      autoTable(doc, {
        head: headers,
        body: data,
        startY: 35,
        styles: { 
          font: 'helvetica', 
          fontSize: 9,
          cellPadding: 2,
          lineColor: [0, 0, 0],
          lineWidth: 0.1
        },
        headStyles: {
          fillColor: [66, 139, 202],
          textColor: [255, 255, 255],
          fontStyle: 'bold'
        },
        columnStyles: columnStyles,
        margin: { top: 35 },
        didDrawPage: function (data) {
          doc.setFontSize(10);
          doc.text(
            'Sayfa ' + doc.internal.getNumberOfPages(),
            doc.internal.pageSize.width / 2,
            doc.internal.pageSize.height - 10,
            { align: 'center' }
          );
        }
      });
      
      doc.save('ogrenci-raporu.pdf');
      setExportModalOpen(false);
    } catch (error) {
      console.error('PDF export hatası:', error);
      alert('PDF oluşturulurken hata oluştu!');
    }
  }, [selectedColumns, getCompanyName, getSubjectNames, getTeacherNames]);
  
  const handleExportExcel = useCallback(async () => {
    try {
      // Tüm veriyi çek
      const response = await axiosConfig.get('/admin/ogrencis?limit=10000&page=1');
      const allData = response.data.data || response.data; // Eski ve yeni format desteği
      
      const data = allData.map(ogr => {
        const row = {
          'Ad Soyad': ogr.name || '-',
          'Email': ogr.email || '-'
        };
        
        if (selectedColumns.durum) {
          row['Durum'] = parseInt(ogr.status) === 1 ? 'Aktif' : 'Pasif';
        }
        if (selectedColumns.kayitDurumu) {
          row['Kayıt Durumu'] = {
            0: 'Devam Ediyor',
            1: 'Derslere Başladı',
            2: 'Vazgeçti',
            3: 'Dersler Bitti',
            4: 'Ödeme Sorunu',
            5: 'Ara Verdi'
          }[ogr.registration_status] || '-';
        }
        if (selectedColumns.veli) {
          row['Veli Adı'] = ogr.parent_name || '-';
          row['Veli Tel'] = ogr.parent_phone || '-';
        }
        if (selectedColumns.sinif) {
          row['Sınıf'] = ogr.sinif || '-';
          row['Okul'] = ogr.okul || '-';
        }
        if (selectedColumns.kayitTarihi) {
          row['Kayıt Tarihi'] = ogr.registration_date || '-';
        }
        if (selectedColumns.sirket) {
          row['Şirket'] = getCompanyName(ogr.registered_system);
        }
        if (selectedColumns.dersler) {
          row['Dersler'] = getSubjectNames(ogr.subjects);
        }
        if (selectedColumns.ogretmenler) {
          row['Öğretmenler'] = getTeacherNames(ogr.teacher_name);
        }
        if (selectedColumns.aciklama) {
          row['Açıklama'] = ogr.aciklama || '-';
        }
        if (selectedColumns.kalanBakiye) {
          row['Kalan Bakiye'] = `${ogr.kalan_bakiye >= 0 ? '+' : ''}${ogr.kalan_bakiye || 0} TL`;
        }
        
        return row;
      });
      
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Öğrenciler');
      XLSX.writeFile(wb, 'ogrenci-raporu.xlsx');
      setExportModalOpen(false);
    } catch (error) {
      console.error('Excel export hatası:', error);
      alert('Excel oluşturulurken hata oluştu!');
    }
  }, [selectedColumns, getCompanyName, getSubjectNames, getTeacherNames]);
  
  // Smart sort options - sabit değerler, useMemo ile optimize edildi
  const smartSortOptions = useMemo(() => [
    { value: 'recent_transaction', label: 'En Son İşlem Yapılanlar (Varsayılan)' },
    { value: 'old_transaction', label: 'En Eski İşlem Yapılanlar' },
    { value: 'recently_added', label: 'Son Eklenenler (Kayıt Tarihine Göre)' },
    { value: 'oldest_added', label: 'İlk Eklenenler (Kayıt Tarihine Göre)' },
    { value: 'name_asc', label: 'A-Z İsim' },
    { value: 'name_desc', label: 'Z-A İsim' },
    { value: 'class_asc', label: 'Sınıf (1-12)' },
    { value: 'class_desc', label: 'Sınıf (12-1)' },
    { value: 'balance_high', label: 'En Yüksek Bakiye' },
    { value: 'balance_low', label: 'En Düşük Bakiye' },
    { value: 'none', label: 'Sıralama Yok' }
  ], []);
  
  // Tüm öğrencilerin seçili olup olmadığını kontrol et - memoized
  const allSelected = useMemo(
    () => ogrencis.length > 0 && ogrencis.every(o => selectedIds.includes(o.id)),
    [ogrencis, selectedIds]
  );
  
  // Sayfa numaraları dizisi oluştur - memoized
  const getPageNumbers = useCallback(() => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        range.push(i);
      }
    }

    range.forEach((i) => {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  }, [currentPage, totalPages]);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-2 sm:p-4 md:p-6">
      <div className="w-full bg-white rounded-lg sm:rounded-xl md:rounded-2xl shadow-xl overflow-hidden">
        {/* Üst başlık */}
        <div className={`px-4 sm:px-6 lg:px-8 py-4 sm:py-6 ${
          statusFilter === 'passive' 
            ? 'bg-gradient-to-r from-red-600 to-red-700' 
            : statusFilter === 'all'
            ? 'bg-gradient-to-r from-gray-600 to-gray-700'
            : 'bg-gradient-to-r from-indigo-600 to-purple-600'
        }`}>
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-3 sm:gap-4">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white flex items-center flex-wrap">
              <svg className="w-6 h-6 sm:w-8 sm:h-8 mr-2 sm:mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
              Öğrenci Yönetimi ({totalCount} kayıt)
              {statusFilter === 'passive' && (
                <span className="ml-3 px-3 py-1 bg-red-800 text-white text-sm rounded-full">
                  Pasif Kayıtlar
                </span>
              )}
              {statusFilter === 'all' && (
                <span className="ml-3 px-3 py-1 bg-gray-800 text-white text-sm rounded-full">
                  Tüm Kayıtlar
                </span>
              )}
              {statusFilter === 'active' && (
                <span className="ml-3 px-3 py-1 bg-green-700 text-white text-sm rounded-full">
                  Aktif Kayıtlar
                </span>
              )}
              {isPending && <span className="ml-2 text-sm">(Güncelleniyor...)</span>}
            </h2>
            <div className="flex flex-wrap gap-2 sm:gap-3">
              <button
                className="bg-yellow-500 text-white px-3 sm:px-4 lg:px-5 py-2 sm:py-2.5 rounded-lg hover:bg-yellow-600 transition-all duration-200 flex items-center shadow-lg text-sm sm:text-base"
                onClick={() => setIsBulkUploadModalOpen(true)}
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                </svg>
                Toplu Yükleme
              </button>
              <button
                className="bg-blue-500 text-white px-3 sm:px-4 lg:px-5 py-2 sm:py-2.5 rounded-lg hover:bg-blue-600 transition-all duration-200 flex items-center shadow-lg text-sm sm:text-base"
                onClick={() => setExportModalOpen(true)}
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Rapor AI
              </button>
              <button
                className="bg-red-500 text-white px-3 sm:px-4 lg:px-5 py-2 sm:py-2.5 rounded-lg hover:bg-red-600 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center shadow-lg text-sm sm:text-base"
                onClick={handleBatchDelete}
                disabled={selectedIds.length === 0}
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Seçili Sil ({selectedIds.length})
              </button>
              <button
                className="bg-emerald-500 text-white px-3 sm:px-4 lg:px-5 py-2 sm:py-2.5 rounded-lg hover:bg-emerald-600 transition-all duration-200 flex items-center shadow-lg text-sm sm:text-base"
                onClick={openFormForCreate}
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Yeni Öğrenci
              </button>
            </div>
          </div>
        </div>
        
        {/* Basit Arama Alanı */}
        <div className="bg-gray-50 px-4 sm:px-6 lg:px-8 py-4 border-b border-gray-200">
          <div className="max-w-md">
            <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">Arama</label>
            <div className="relative">
              <input
                type="text"
                className="w-full pl-10 pr-4 py-2 sm:py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                placeholder="Ad, Veli, Telefon, Email, Şehir, Sınıf, Okul..."
                value={inputValue}
                onChange={(e) => handleSearchInputChange(e.target.value)}
              />
              <svg className="w-5 h-5 absolute left-3 top-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>
        </div>
        
        {/* Akıllı Sıralama ve Filtreler */}
        <div className="px-4 sm:px-6 lg:px-8 py-3 sm:py-4 bg-gray-50 border-b border-gray-200">
          <div className="flex flex-col gap-4">
            {/* Üst Satır - Sıralama ve Durum Filtreleri */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full sm:w-auto">
                <label className="text-xs sm:text-sm font-semibold text-gray-700">Akıllı Sıralama:</label>
                <select
                  className="w-full sm:w-auto px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  value={selectedSortOption}
                  onChange={(e) => handleSmartSort(e.target.value)}
                >
                  {smartSortOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                
                {/* Durum Filtresi */}
                <div className="flex items-center gap-2">
                  <label className="text-xs sm:text-sm font-semibold text-gray-700">Durum:</label>
                  <select
                    className="px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="active">Aktif</option>
                    <option value="passive">Pasif</option>
                    <option value="all">Tümü</option>
                  </select>
                </div>
                
                {/* Kayıt Durumu Filtresi */}
                <div className="flex items-center gap-2">
                  <label className="text-xs sm:text-sm font-semibold text-gray-700">Kayıt Durumu:</label>
                  <select
                    className="px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    value={registrationStatusFilter}
                    onChange={(e) => {
                      setRegistrationStatusFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="all">Tümü</option>
                    <option value="0">Devam Ediyor</option>
                    <option value="1">Derslere Başladı</option>
                    <option value="2">Vazgeçti</option>
                    <option value="3">Dersler Bitti</option>
                    <option value="4">Ödeme Sorunu</option>
                    <option value="5">Ara Verdi</option>
                  </select>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full sm:w-auto">
                <label className="text-xs sm:text-sm font-semibold text-gray-700">Sayfa başına:</label>
                <select
                  className="w-full sm:w-auto px-3 sm:px-4 py-1.5 sm:py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  value={perPage}
                  onChange={(e) => handlePerPageChange(e.target.value)}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                  <option value="99999">Tümünü Göster</option>
                </select>
                <span className="text-xs sm:text-sm text-gray-500">
                  {perPage === 99999 ? (
                    <>
                      Toplam <span className="font-bold text-indigo-600">{totalCount}</span> kayıt gösteriliyor
                      {totalCount > 1000 && (
                        <span className="ml-2 text-amber-600 font-semibold">
                          (⚠ Yükleme zaman alabilir)
                        </span>
                      )}
                    </>
                  ) : (
                    `Sayfa ${currentPage} / ${totalPages}`
                  )}
                </span>
              </div>
            </div>
            
            {/* Alt Satır - Öğretmen ve Öğrenci Filtreleri */}
            <div className="flex flex-col lg:flex-row gap-3">
              {/* Öğretmen Filtresi - ARAÇLI VE SEÇMELİ */}
              <div className="relative flex-1" ref={teacherDropdownRef}>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Öğretmen (Yazın veya Seçin)</label>
                <div className="relative">
                  <input
                    type="text"
                    value={teacherSearchText}
                    onChange={(e) => {
                      setTeacherSearchText(e.target.value);
                      setTeacherFilter('all');
                      setIsTeacherDropdownOpen(true);
                    }}
                    onFocus={() => setIsTeacherDropdownOpen(true)}
                    placeholder="Öğretmen ara veya seç..."
                    className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  />
                  <button
                    type="button"
                    onClick={() => setIsTeacherDropdownOpen(!isTeacherDropdownOpen)}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isTeacherDropdownOpen ? "M5 15l7-7 7 7" : "M19 9l-7 7-7-7"} />
                    </svg>
                  </button>
                  {teacherFilter !== 'all' && (
                    <button
                      type="button"
                      onClick={() => {
                        setTeacherFilter('all');
                        setTeacherSearchText('');
                      }}
                      className="absolute right-10 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
                
                {/* Dropdown Listesi */}
                {isTeacherDropdownOpen && (
                  <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    <button
                      type="button"
                      onClick={() => {
                        setTeacherFilter('all');
                        setTeacherSearchText('');
                        setIsTeacherDropdownOpen(false);
                      }}
                      className="w-full px-3 py-2 text-left hover:bg-indigo-50 text-sm font-semibold text-indigo-600 border-b border-gray-200"
                    >
                      Tüm Öğretmenler
                    </button>
                    {filteredTeachers.length > 0 ? (
                      filteredTeachers.map(teacher => (
                        <button
                          key={teacher.id}
                          type="button"
                          onClick={() => {
                            setTeacherFilter(teacher.id);
                            setTeacherSearchText(teacher.adi);
                            setIsTeacherDropdownOpen(false);
                          }}
                          className={`w-full px-3 py-2 text-left hover:bg-indigo-50 text-sm transition-colors ${
                            teacherFilter === teacher.id ? 'bg-indigo-100 text-indigo-700 font-semibold' : ''
                          }`}
                        >
                          {teacher.adi}
                        </button>
                      ))
                    ) : (
                      <div className="px-3 py-2 text-sm text-gray-500 italic">
                        Öğretmen bulunamadı
                      </div>
                    )}
                  </div>
                )}
              </div>
              
              {/* Öğrenci Filtresi - ARAÇLI VE SEÇMELİ */}
              <div className="relative flex-1" ref={studentDropdownRef}>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Öğrenci (Yazın veya Seçin)</label>
                <div className="relative">
                  <input
                    type="text"
                    value={studentSearchText}
                    onChange={(e) => {
                      setStudentSearchText(e.target.value);
                      setStudentFilter('all');
                      setIsStudentDropdownOpen(true);
                    }}
                    onFocus={() => setIsStudentDropdownOpen(true)}
                    placeholder="Öğrenci ara veya seç..."
                    className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                  />
                  <button
                    type="button"
                    onClick={() => setIsStudentDropdownOpen(!isStudentDropdownOpen)}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isStudentDropdownOpen ? "M5 15l7-7 7 7" : "M19 9l-7 7-7-7"} />
                    </svg>
                  </button>
                  {studentFilter !== 'all' && (
                    <button
                      type="button"
                      onClick={() => {
                        setStudentFilter('all');
                        setStudentSearchText('');
                      }}
                      className="absolute right-10 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  )}
                </div>
                
                {/* Dropdown Listesi */}
                {isStudentDropdownOpen && (
                  <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                    <button
                      type="button"
                      onClick={() => {
                        setStudentFilter('all');
                        setStudentSearchText('');
                        setIsStudentDropdownOpen(false);
                      }}
                      className="w-full px-3 py-2 text-left hover:bg-indigo-50 text-sm font-semibold text-indigo-600 border-b border-gray-200"
                    >
                      Tüm Öğrenciler
                    </button>
                    {filteredStudents.length > 0 ? (
                      filteredStudents.map(student => (
                        <button
                          key={student.id}
                          type="button"
                          onClick={() => {
                            setStudentFilter(student.id);
                            setStudentSearchText(student.name);
                            setIsStudentDropdownOpen(false);
                          }}
                          className={`w-full px-3 py-2 text-left hover:bg-indigo-50 text-sm transition-colors ${
                            studentFilter === student.id ? 'bg-indigo-100 text-indigo-700 font-semibold' : ''
                          }`}
                        >
                          {student.name}
                          {student.parent_name && (
                            <span className="text-xs text-gray-500 ml-2">({student.parent_name})</span>
                          )}
                        </button>
                      ))
                    ) : (
                      <div className="px-3 py-2 text-sm text-gray-500 italic">
                        Öğrenci bulunamadı
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Responsive Tablo/Kart Görünümü */}
        <div className="w-full">
          {/* Desktop: 1536px üzeri - Tam tablo */}
          <div className={`hidden 2xl:block overflow-auto max-h-[700px] border rounded-lg ${
            statusFilter === 'passive' 
              ? 'border-red-400 bg-red-50/30' 
              : statusFilter === 'all'
              ? 'border-gray-400 bg-gray-50/30'
              : 'border-gray-200'
          }`}>
            {loading ? (
              <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
              </div>
            ) : (
              <table className="w-full relative text-sm">
              <thead className={`border-b ${
                statusFilter === 'passive' 
                  ? 'bg-red-100 border-red-300' 
                  : statusFilter === 'all'
                  ? 'bg-gray-100 border-gray-300'
                  : 'bg-gray-50 border-gray-200'
              }`}>
                <tr>
                  <th className={`px-2 py-2 text-left sticky left-0 z-20 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] ${
                    statusFilter === 'passive' ? 'bg-red-100' : 'bg-gray-50'
                  }`}>
                    <input
                      type="checkbox"
                      checked={allSelected}
                      onChange={() => {
                        if (allSelected) {
                          setSelectedIds([]);
                        } else {
                          setSelectedIds(ogrencis.map(o => o.id));
                        }
                      }}
                      className="w-4 h-4 text-indigo-600 rounded focus:ring-indigo-500"
                    />
                  </th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase sticky left-9 z-20 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] min-w-[120px] ${
                    statusFilter === 'passive' ? 'bg-red-100 text-red-900' : 'bg-gray-50 text-gray-700'
                  }`}>
                    Ad Soyad
                  </th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[60px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>Durum</th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[120px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>Email</th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[100px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>Telefon</th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[50px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>Sınıf</th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[90px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>
                    K.Durumu
                  </th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[80px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>
                    Kayıt
                  </th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[80px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>
                    Son İşlem
                  </th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[120px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>Dersler</th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[120px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>
                    Öğretmenler
                  </th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[130px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>Açıklama</th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[80px] ${
                    statusFilter === 'passive' ? 'text-red-900' : 'text-gray-700'
                  }`}>
                    Bakiye
                  </th>
                  <th className={`px-2 py-2 text-left text-xs font-semibold uppercase min-w-[130px] sticky right-0 z-20 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.1)] ${
                    statusFilter === 'passive' ? 'bg-red-100 text-red-900' : 'bg-gray-50 text-gray-700'
                  }`}>İşlemler</th>
                </tr>
              </thead>
              <tbody className={`divide-y ${
                statusFilter === 'passive' ? 'divide-red-200' : 'divide-gray-200'
              }`}>
                {ogrencis.map((o) => (
                  <OgrenciTableRow
                    key={o.id}
                    ogrenci={o}
                    isSelected={selectedIds.includes(o.id)}
                    isExpanded={expandedRows.has(o.id)}
                    onSelectChange={handleSelectChange}
                    onEdit={openFormForEdit}
                    onDelete={handleDelete}
                    onToggleExpand={handleToggleExpand}
                    onShowPastLessons={fetchStudentLessons}
                    onShowPayments={showPayments}
                    onShowBalanceDetail={showBalanceDetail}
                    onToggleTeacherStatus={handleToggleTeacherStatus}
                    getSubjectNames={getSubjectNames}
                    getTeacherNames={getTeacherNames}
                    getCompanyName={getCompanyName}
                    statusFilter={statusFilter}
                    teachers={teachers}
                  />
                ))}
                {ogrencis.length === 0 && (
                  <tr>
                    <td colSpan={14} className="px-6 py-12 text-center">
                      <div className="flex flex-col items-center">
                        <svg className="w-12 h-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-gray-500">Kayıt bulunamadı</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            )}
          </div>

          {/* Laptop/Tablet: 1024px-1535px - Sınırlı tablo */}
          <div className={`hidden lg:block 2xl:hidden overflow-auto max-h-[700px] border rounded-lg ${
            statusFilter === 'passive' 
              ? 'border-red-400 bg-red-50/30' 
              : statusFilter === 'all'
              ? 'border-gray-400 bg-gray-50/30'
              : 'border-gray-200'
          }`}>
            {loading ? (
              <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
              </div>
            ) : (
              <table className="w-full table-fixed">
                <thead className={`border-b ${
                  statusFilter === 'passive' 
                    ? 'bg-red-100 border-red-300' 
                    : statusFilter === 'all'
                    ? 'bg-gray-100 border-gray-300'
                    : 'bg-gray-50 border-gray-200'
                }`}>
                  <tr>
                    <th className="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-[20%]">Ad Soyad</th>
                    <th className="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-[10%]">Durum</th>
                    <th className="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-[22%]">Email</th>
                    <th className="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-[14%]">Sınıf</th>
                    <th className="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-[14%]">Kayıt Durumu</th>
                    <th className="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-[10%]">Kalan Bakiye</th>
                    <th className="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase w-[10%]">İşlemler</th>
                  </tr>
                </thead>
                <tbody className={`divide-y ${
                  statusFilter === 'passive' ? 'divide-red-200' : 'divide-gray-200'
                }`}>
                  {ogrencis.map((o) => {
                    const isPassive = parseInt(o.status) === 0;
                    return (
                    <tr key={o.id} className={`hover:opacity-95 transition-all duration-200 ${
                      isPassive ? 'bg-red-200 opacity-95' : 'hover:bg-gray-50'
                    }`}>
                      <td
                        title={o.name}
                        className={`px-3 py-3 text-sm font-medium truncate ${
                          isPassive ? 'text-red-900 font-semibold' : 'text-gray-900'
                        }`}
                      >
                        {o.name}
                      </td>
                      <td className="px-4 py-3">
                        <span className={`inline-flex items-center px-2 py-1 text-xs font-semibold rounded-full ${
                          isPassive 
                            ? 'bg-red-600 text-white border border-red-700' 
                            : 'bg-green-100 text-green-800'
                        }`}>
                          {isPassive ? 'Pasif' : 'Aktif'}
                        </span>
                      </td>
                      <td
                        title={o.email || '-'}
                        className={`px-3 py-3 text-sm truncate ${
                          isPassive ? 'text-red-900 font-medium' : 'text-gray-600'
                        }`}
                      >
                        {o.email || '-'}
                      </td>
                      <td className="px-3 py-3 text-sm text-gray-600">
                        {Array.isArray(o.sinif) && o.sinif.length > 0 ? (
                          <div className="flex flex-wrap gap-1">
                            {o.sinif.map((s, idx) => {
                              const displayText = s === 'Anaokulu' ? 'Anaokulu' :
                                                 s === 'Mezun' ? 'Mezun' :
                                                 s === 'Üniversite' ? 'Üniversite' :
                                                 `${s}. Sınıf`;
                              return (
                                <span key={idx} className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                  {displayText}
                                </span>
                              );
                            })}
                          </div>
                        ) : (o.sinif || '-')}
                      </td>
                      <td className="px-3 py-3">
                        <span
                          title={{
                            0: 'Devam Ediyor',
                            1: 'Derslere Başladı',
                            2: 'Vazgeçti',
                            3: 'Dersler Bitti',
                            4: 'Ödeme Sorunu',
                            5: 'Ara Verdi'
                          }[o.registration_status] || '-'}
                          className="inline-block max-w-full truncate px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800"
                        >
                          {{
                            0: 'Devam Ediyor',
                            1: 'Derslere Başladı',
                            2: 'Vazgeçti',
                            3: 'Dersler Bitti',
                            4: 'Ödeme Sorunu',
                            5: 'Ara Verdi'
                          }[o.registration_status] || '-'}
                        </span>
                      </td>
                      <td className="px-3 py-3 text-sm font-semibold">
                        <span className={o.kalan_bakiye >= 0 ? 'text-green-600' : 'text-red-600'}>
                          {o.kalan_bakiye >= 0 ? '+' : ''}{o.kalan_bakiye || 0} TL
                        </span>
                      </td>
                      <td className="px-3 py-3">
                        <div className="flex flex-wrap gap-1">
                          <button
                            onClick={() => openFormForEdit(o)}
                            className="p-1 hover:bg-blue-100 rounded"
                            title="Düzenle"
                          >
                            <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => showPayments(o.id, o.name)}
                            className="p-1 hover:bg-green-100 rounded"
                            title="Ödemeler"
                          >
                            <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => handleDelete(o.id)}
                            className="p-1 hover:bg-red-100 rounded"
                            title="Sil"
                          >
                            <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                  })}
                </tbody>
              </table>
            )}
          </div>

          {/* Mobil/Tablet: 1024px altı - Kart görünümü */}
          <div className="lg:hidden">
            {loading ? (
              <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {ogrencis.map((o) => {
                  const isPassive = parseInt(o.status) === 0;
                  return (
                  <div key={o.id} className={`rounded-lg shadow-md border-2 p-4 transition-all duration-200 ${
                    isPassive 
                      ? 'bg-red-200 border-red-500 opacity-95' 
                      : 'bg-white border-gray-200'
                  }`}>
                    {/* Üst Kısım */}
                    <div className="flex justify-between items-start mb-3">
                      <div className="flex-1">
                        <h3 className={`font-semibold text-base ${
                          isPassive ? 'text-red-900' : 'text-gray-900'
                        }`}>{o.name}</h3>
                        <p className="text-sm text-gray-500 mt-1">{o.email || '-'}</p>
                        {/* Durum Badge */}
                        <span className={`inline-flex items-center px-2 py-1 text-xs font-semibold rounded-full mt-1 ${
                          isPassive 
                            ? 'bg-red-600 text-white border border-red-700' 
                            : 'bg-green-100 text-green-800'
                        }`}>
                          <span className={`w-2 h-2 rounded-full mr-1.5 ${
                            isPassive ? 'bg-white' : 'bg-green-400'
                          }`}></span>
                          {isPassive ? 'Pasif' : 'Aktif'}
                        </span>
                      </div>
                      <span className="ml-2 inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800 whitespace-nowrap">
                        {{
                          0: 'Devam',
                          1: 'Başladı',
                          2: 'Vazgeçti',
                          3: 'Bitti',
                          4: 'Ödeme!',
                          5: 'Ara'
                        }[o.registration_status] || '-'}
                      </span>
                    </div>
                    
                    {/* Bilgiler - Kompakt */}
                    <div className="grid grid-cols-2 gap-2 text-sm mb-3">
                      <div>
                        <span className="text-gray-500">Telefon:</span>
                        <p className={`font-medium ${
                          isPassive ? 'text-red-900' : 'text-gray-900'
                        }`}>{o.parent_phone || '-'}</p>
                      </div>
                      <div>
                        <span className="text-gray-500">Sınıf:</span>
                        {Array.isArray(o.sinif) && o.sinif.length > 0 ? (
                          <div className="flex flex-wrap gap-0.5">
                            {o.sinif.slice(0, 2).map((s, idx) => {
                              const displayText = s === 'Anaokulu' ? 'AO' :
                                                 s === 'Mezun' ? 'Mzn' :
                                                 s === 'Üniversite' ? 'Üni' :
                                                 s;
                              return (
                                <span key={idx} className="inline-flex items-center px-1 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                  {displayText}
                                </span>
                              );
                            })}
                            {o.sinif.length > 2 && (
                              <span className="text-xs text-gray-500">+{o.sinif.length - 2}</span>
                            )}
                          </div>
                        ) : (
                          <p className={`font-medium ${
                            isPassive ? 'text-red-900' : 'text-gray-900'
                          }`}>{o.sinif || '-'}</p>
                        )}
                      </div>
                      <div>
                        <span className="text-gray-500">Kayıt:</span>
                        <p className={`font-medium ${
                          isPassive ? 'text-red-900' : 'text-gray-900'
                        }`}>{o.registration_date || '-'}</p>
                      </div>
                      <div>
                        <span className="text-gray-500">Bakiye:</span>
                        <p className={`font-bold ${o.kalan_bakiye >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                          {o.kalan_bakiye >= 0 ? '+' : ''}{o.kalan_bakiye || 0} TL
                        </p>
                      </div>
                    </div>

                    {/* Butonlar - Kompakt */}
                    <div className="flex gap-2">
                      <button
                        onClick={() => openFormForEdit(o)}
                        className="flex-1 px-3 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-600 rounded text-sm font-medium transition-colors"
                      >
                        Düzenle
                      </button>
                      <button
                        onClick={() => showPayments(o.id, o.name)}
                        className="flex-1 px-3 py-1.5 bg-green-50 hover:bg-green-100 text-green-600 rounded text-sm font-medium transition-colors"
                      >
                        Ödemeler
                      </button>
                      <button
                        onClick={() => handleDelete(o.id)}
                        className="px-3 py-1.5 bg-red-50 hover:bg-red-100 text-red-600 rounded text-sm font-medium transition-colors"
                      >
                        Sil
                      </button>
                    </div>
                  </div>
                );
                })}
              </div>
            )}
          </div>

          {/* Boş durum */}
          {!loading && ogrencis.length === 0 && (
            <div className="text-center py-12">
              <svg className="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="text-gray-500">Kayıt bulunamadı</p>
            </div>
          )}
        </div>
        
        {/* Sayfalama Kontrolleri ve Alt Bilgi */}
        {totalPages > 1 && (
          <div className="px-4 sm:px-6 lg:px-8 py-3 sm:py-4 bg-gray-50 border-t border-gray-200">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs sm:text-sm text-gray-700 text-center sm:text-left">
                {perPage === 99999 ? (
                  <>Toplam <span className="font-semibold">{totalCount}</span> kayıt gösteriliyor</>
                ) : (
                  <>Toplam <span className="font-semibold">{totalCount}</span> kayıttan{' '}
                  <span className="font-semibold">{(currentPage - 1) * perPage + 1}</span> -{' '}
                  <span className="font-semibold">{Math.min(currentPage * perPage, totalCount)}</span> arası gösteriliyor</>
                )}
              </p>
              
              {perPage !== 99999 && (
                <nav className="flex items-center space-x-1">
                  <button
                    onClick={goToFirstPage}
                    disabled={currentPage === 1}
                    className="p-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    title="İlk Sayfa"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                    </svg>
                  </button>
                  
                  <button
                    onClick={goToPrevPage}
                    disabled={currentPage === 1}
                    className="p-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    title="Önceki Sayfa"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  
                  {/* Sayfa numaraları */}
                  {getPageNumbers().map((number, index) => {
                    if (number === '...') {
                      return (
                        <span key={index} className="px-3 py-2 text-gray-500">
                          ...
                        </span>
                      );
                    }
                    return (
                      <button
                        key={number}
                        onClick={() => goToPage(number)}
                        className={`px-3 py-2 rounded-lg border transition-colors ${
                          currentPage === number
                            ? 'bg-indigo-600 text-white border-indigo-600'
                            : 'border-gray-300 bg-white hover:bg-gray-100'
                        }`}
                      >
                        {number}
                      </button>
                    );
                  })}
                  
                  <button
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    className="p-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    title="Sonraki Sayfa"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                  
                  <button
                    onClick={goToLastPage}
                    disabled={currentPage === totalPages}
                    className="p-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    title="Son Sayfa"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                    </svg>
                  </button>
                </nav>
              )}
            </div>
          </div>
        )}
      </div>
      
      {/* Form Modal */}
      <OgrenciFormModal
        isOpen={isFormOpen}
        onClose={closeForm}
        onSubmit={handleSubmitForm}
        formData={formData}
        setFormData={setFormData}
        currentOgrenci={currentOgrenci}
        companies={companies}
      />
      
      {/* Export Modal */}
      <OgrenciExportModal
        isOpen={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        onExportPDF={handleExportPDF}
        onExportExcel={handleExportExcel}
      />
      
      {/* Geçmiş Dersler Modal */}
      <OgrenciPastLessonsModal
        isOpen={isPastLessonsModalOpen}
        onClose={closePastLessonsModal}
        studentInfo={selectedStudentInfo}
        lessons={selectedStudentLessons}
        loading={loadingLessons}
        teachers={teachers}
        lessonGroups={lessonGroups}
      />
      
      {/* Ödeme Modal */}
      <OdemeModal
        isOpen={isPaymentModalOpen}
        onClose={closePaymentModal}
        studentInfo={selectedStudentForPayment}
        onPaymentAdded={() => {
          console.log('Yeni ödeme eklendi');
          fetchStudentsWithPagination();
        }}
      />
      
      {/* Bakiye Detay Modal */}
      <StudentBalanceDetailModal
        isOpen={isBalanceDetailModalOpen}
        onClose={closeBalanceDetailModal}
        studentInfo={selectedStudentForBalance}
      />
      
      {/* Toplu Yükleme Modal */}
      <BulkUploadModal
        isOpen={isBulkUploadModalOpen}
        onClose={() => setIsBulkUploadModalOpen(false)}
        onSuccess={() => {
          setIsBulkUploadModalOpen(false);
          fetchStudentsWithPagination();
        }}
        companies={companies}
      />

    </div>
  );
};

export default OgrenciListPage;
